import React from "react";
import {ReactComponent as SubsWidget} from "../../../assets/images/subswidget.svg";
import { Link } from "react-router-dom";

export const SubscriptionWidget = () => {
  return (
    <>
      <Link to="#">
        <SubsWidget />
        
      </Link>
    </>
  );
};
